/**
 * TM Wishlist — localStorage based, no account needed
 * Stores: array of { handle, title, price, image, url }
 */
(function() {
  const STORAGE_KEY = 'tm_wishlist_v1';
  const TM_TRACKER_URL = 'https://script.google.com/macros/s/AKfycbyn5Z1HdbpyjkbuqsP_OJFVcRTKcM2abXMmITK3-8u6R53YDXhJRX_vG7AFKSJ7oGt2/exec';

  // ---------- Core API ----------
  window.TMWishlist = {
    get: function() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
      catch(e) { return []; }
    },
    save: function(list) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    },
    has: function(handle) {
      return this.get().some(function(p) { return p.handle === handle; });
    },
    add: function(product) {
      var list = this.get();
      if (!this.has(product.handle)) {
        list.push(product);
        this.save(list);
        this._dispatch('wishlist:add', product);
        this._track('add', product);
      }
    },
    remove: function(handle) {
      var list = this.get().filter(function(p) { return p.handle !== handle; });
      this.save(list);
      this._dispatch('wishlist:remove', { handle: handle });
      this._track('remove', { handle: handle });
    },
    toggle: function(product) {
      if (this.has(product.handle)) { this.remove(product.handle); return false; }
      else { this.add(product); return true; }
    },
    count: function() { return this.get().length; },
    clear: function() { localStorage.removeItem(STORAGE_KEY); },
    _dispatch: function(name, detail) {
      document.dispatchEvent(new CustomEvent(name, { detail: detail }));
    },
    _track: function(action, product) {
      try {
        var payload = {
          action: action,
          handle: product.handle || '',
          title: product.title || '',
          price: product.price || '',
          url: product.url || ('/products/' + (product.handle || '')),
          timestamp: new Date().toISOString(),
          userAgent: navigator.userAgent ? navigator.userAgent.substring(0, 150) : ''
        };
        fetch(TM_TRACKER_URL, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
      } catch(e) { /* silently fail */ }
    }
  };

  // ---------- Sync all hearts on the page ----------
  function syncHearts() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(function(btn) {
      var handle = btn.getAttribute('data-wishlist-btn');
      var active = window.TMWishlist.has(handle);
      btn.classList.toggle('tm-heart--active', active);
      btn.setAttribute('aria-label', active ? 'Retirer des favoris' : 'Ajouter aux favoris');
    });
    // Update counter badges
    var count = window.TMWishlist.count();
    document.querySelectorAll('[data-wishlist-count]').forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  // ---------- Click handler ----------
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var handle = btn.getAttribute('data-wishlist-btn');
    var title = btn.getAttribute('data-title') || '';
    var price = btn.getAttribute('data-price') || '';
    var image = btn.getAttribute('data-image') || '';
    var url = btn.getAttribute('data-url') || ('/products/' + handle);

    var added = window.TMWishlist.toggle({ handle: handle, title: title, price: price, image: image, url: url });

    // Toast notification
    showToast(added ? '\u2764\uFE0F Ajouté aux favoris' : '\uD83E\uDD0D Retiré des favoris');
    syncHearts();
  });

  // ---------- Toast ----------
  function showToast(msg) {
    var existing = document.getElementById('tm-wl-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.id = 'tm-wl-toast';
    toast.textContent = msg;
    toast.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:#111;color:#fff;padding:10px 20px;border-radius:999px;font-size:14px;font-weight:600;z-index:9999;white-space:nowrap;opacity:0;transition:opacity .2s;pointer-events:none;';
    document.body.appendChild(toast);
    requestAnimationFrame(function() {
      toast.style.opacity = '1';
      setTimeout(function() {
        toast.style.opacity = '0';
        setTimeout(function() { if (toast.parentNode) toast.remove(); }, 250);
      }, 2000);
    });
  }

  // ---------- Wishlist page renderer ----------
  function renderWishlistPage() {
    var container = document.getElementById('tm-wishlist-page');
    if (!container) return;
    var list = window.TMWishlist.get();
    if (list.length === 0) {
      container.innerHTML = '<p class="tm-wl-empty">Ta wishlist est vide pour le moment&nbsp;\u{1F614}<br><a href="/collections/all" class="tm-wl-shop-btn">D\u00E9couvrir les produits</a></p>';
      return;
    }
    var html = '<div class="tm-wl-grid">';
    list.forEach(function(p) {
      html += '<div class="tm-wl-card">' +
        '<a href="' + p.url + '" class="tm-wl-card__img-wrap">' +
        (p.image ? '<img src="' + p.image + '" alt="' + p.title + '" loading="lazy">' : '<div class="tm-wl-card__no-img"></div>') +
        '</a>' +
        '<div class="tm-wl-card__info">' +
        '<a href="' + p.url + '" class="tm-wl-card__title">' + p.title + '</a>' +
        '<span class="tm-wl-card__price">' + p.price + '</span>' +
        '<button class="tm-wl-card__remove" data-remove="' + p.handle + '" aria-label="Retirer">&#10005; Retirer</button>' +
        '</div></div>';
    });
    html += '</div>';
    container.innerHTML = html;
  }

  document.addEventListener('click', function(e) {
    var removeBtn = e.target.closest('[data-remove]');
    if (!removeBtn) return;
    var handle = removeBtn.getAttribute('data-remove');
    window.TMWishlist.remove(handle);
    renderWishlistPage();
    syncHearts();
  });

  document.addEventListener('wishlist:add', syncHearts);
  document.addEventListener('wishlist:remove', syncHearts);

  // ---------- Init ----------
  document.addEventListener('DOMContentLoaded', function() {
    syncHearts();
    renderWishlistPage();
  });
  // Also sync immediately if DOM is already ready
  if (document.readyState !== 'loading') {
    syncHearts();
    renderWishlistPage();
  }

  // Card click navigation: restore image click -> product URL
  // Since ::after has pointer-events:none, we handle navigation via JS delegation
  document.addEventListener('click', function(e) {
    // If click was on or inside the heart button, do nothing (let wishlist handle it)
    if (e.target.closest('.tm-card-heart')) return;
    // If click was inside a card-wrapper that has a heart button
    var wrapper = e.target.closest('.card-wrapper:has(.tm-card-heart)');
    if (!wrapper) return;
    // Don't trigger if click was on an actual <a> tag (title link etc)
    if (e.target.closest('a')) return;
    // Find the product link (CardLink or StandardCardNoMediaLink)
    var link = wrapper.querySelector('a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]');
    if (link && link.href) {
      window.location.href = link.href;
    }
  });
})();
